import React from "react";
import { Source, Layer } from "react-map-gl";

const DistrictsLayer = ({ data, zoomFeatureFilter }) => {
  if (!data) {
    return null;
  }

  const linePaint = {
    "line-color": "#841FA0",
    "line-opacity": 1,
    "line-width": 2,
  };

  const fillPaint = {
    "fill-color": [
      "case",
      [
        "all",
        ["==", ["get", "state"], zoomFeatureFilter.state],
        ["==", ["get", "id"], zoomFeatureFilter.id],
      ],
      "#841FA0",
      "#fff",
    ],
    "fill-opacity": 0.5,
    "fill-outline-color": "#841FA0"
  };

  return (
    <Source type="geojson" data={data}>
      <Layer id="districts-lines" type="line" paint={linePaint} />
      <Layer id="districts-fills" type="fill" paint={fillPaint} />
    </Source>
  );
};

export default DistrictsLayer;
